export const SocketActions = {
    EXPRESS_DELIVERY_CREATE: 'EXPRESS_DELIVERY_CREATE',
    EXPRESS_DELIVERY_UPDATE: 'EXPRESS_DELIVERY_UPDATE',
    GUIDE_UPDATE: 'GUIDE_UPDATE',
    GUIDE_CREATE: 'GUIDE_CREATE',
};
